<div class="PrintCount Inventory">
  <div>
    <div class="fx-xs-column fx-row fx-align-space-between-center">
      <div class="fx-row fx-align-start-center fx-flex-30" id="header__wrapper">
        <app-count-header *ngIf="inventory$ && inventory$.invBatchName" title="{{inventory$.invBatchName}}"></app-count-header>
      </div>
      <h2 class="text-center w-100">{{ "inventory.printCount" | translate }}</h2>
      <div class="fx-flex fx-align-end-center fx-flex-30" class="invButton__wrapper">
        <div class="fx-layout-lt-md-column fx-row fx-gap-20px">
          <button mat-raised-button color="primary" (click)="sendReport()" class="fx-align-simple-center">
            {{ "sendReport" | translate }}
          </button>
          <app-select-report></app-select-report>
          <button mat-raised-button color="primary" (click)="generatePDF()" class="fx-align-simple-center">
            {{ "generatePDF" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <app-mid-header [inventory]="inventory$"></app-mid-header>
    <br />
    <br />
      <div>
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortData($event)"   width="100%" id="main-table">

          <ng-container matColumnDef="prdNameEn">
            <mat-header-cell *matHeaderCellDef mat-sort-header="prdNameEn"> {{ "products.table.prdNameEn" | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> <span [innerHTML]="element?.prdNameEn"></span> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="productStorageName">
            <mat-header-cell *matHeaderCellDef mat-sort-header="productStorageName"> {{ "storages" | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> <span [innerHTML]="element?.productStorageName"></span> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="prdCasePack">
            <mat-header-cell *matHeaderCellDef mat-sort-header="prdCasePack"> UOM
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.prdCasePack}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="invitmCount">
            <mat-header-cell *matHeaderCellDef mat-sort-header="invitmCount"> {{ "inventory.count" | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element?.invitmCount }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="pcmDesc">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "countType" | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.pcmDesc }}/ {{ element.pcmItemQty }} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" appInventoryRow [prdID]="row.prdID" [invitmID]="row.invitmID"></mat-row>
        </table>
      </div>
    <table class="bottom-table">
      <thead>
        <tr>
          <th>{{ "productsCounted" | translate }}</th>
          <th>{{ "inventory.unitsCounted" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{count}}</td>
          <td>{{sum?.toFixed(2)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
